<style>
.p-message-error{
  color:#dc2626;
  font-size: 14px;
}
.p-message-content{
  height: fit-content!important;
}
.col-bottoni {
  display: flex;
  grid-column-gap: 20px;
  justify-content: end;
}
</style>

<template>
  <div v-if="show" id="simple-modal-overlay" class="k-overlay" @click="annulla"></div>
  <div v-if="show" id="simple-modal" class="card-img-overlay popup-global-position modal-cambia-esecutore" style="overflow: auto">
    <div class="card mb-4">
      <div class="card-body p-3">
        <h4>Cambia esecutore</h4>
        <CustomForm v-slot="$form" :resolver="resolver" :initialValues="initialValues" @submit="onFormSubmit" class="flex flex-col gap-4 w-full md:w-56" style="margin-top: 30px;">
          <div class="row">
            <div class="col-md-6 col-12">
              <div class="flex flex-col gap-1">
                <FloatLabel class="w-full md:w-56" variant="on">
                  <CustomSelect filter name="esecutore" :options="esecutori" optionLabel="descrizione" optionValue="id_account" :loading="esecutori.length<=0"   />
                  <!--            <Message v-if="$form.city?.invalid" severity="error" size="small" variant="simple">{{ $form.city.error.message }}</Message>-->

                  <label for="over_label">Esecutori</label>

                </FloatLabel>
                <Message v-if="$form.esecutore?.invalid" severity="error" variant="simple" size="small">Selezionare un esecutore</Message>
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="flex flex-col gap-1">
                <FloatLabel class="w-full md:w-56" variant="on">
                  <CustomSelect filter name="status" :options="stati" optionLabel="titolo" optionValue="titolo"    />
                  <label for="over_label">Status</label>
                </FloatLabel>
                <Message v-if="$form.status?.invalid" severity="error" variant="simple" size="small">Selezionare uno status</Message>
              </div>
            </div>
            <div class="col-12 mt-10">
              <div class="flex flex-col gap-1">
                <FloatLabel variant="on" class="w-full">
                  <CustomTextArea name="descrizione" rows="5" cols="10" />
                  <label for="over_label">DOD</label>
                </FloatLabel>
                <Message v-if="$form.descrizione?.invalid" severity="error" variant="simple" size="small">Inserire una DOD
                </Message>
              </div>
            </div>
            <div class="col-12 mt-5 col-bottoni">
              <CustomButton type="submit" severity="secondary" label="Cambia esecutore"></CustomButton>
            </div>
          </div>
        </CustomForm>
      </div>
    </div>
  </div>
</template>

<script>
import {Form as CustomForm} from "@primevue/forms";
import CustomSelect from "primevue/select";
import FloatLabel from "primevue/floatlabel";
import CustomButton from "primevue/button";
import Message from 'primevue/message';
import {ref} from "vue";
import * as $ from 'jquery';
import CustomTextArea from "primevue/textarea";
export default {
  name: "KModalCambiaEsecutore",
  components:{CustomTextArea, CustomForm, CustomSelect, FloatLabel, CustomButton,Message},
  data() {
    return {
      status:'',
      idTask:-1,
      oldOwner:-1,
      oldDescrizione:'',
      descrizione:'',
      idTicket:-1,
      orePreviste:-1,
      forcePM:false,
      idPmForzato:-1,
      stati:[{
        titolo:"BACKLOG",
      },{
        titolo:"TODO",
      },{
        titolo:"REVIEW",
      },{
        titolo:"DONE",
      }],
      esecutori:[],
      show: false,
      initialValues:{

      }
    }
  },
  setup(){
    return{
      form:ref("$form")
    }
  },
  created() {
    $(document).keyup(function (e) {
      if (e.key === "Escape" && this.show) {
        this.annulla();
      }
    }.bind(this));

    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'startCambiaEsecutore') {
        this.show = true;
        this.idTask=mutation.payload.idTask;
        this.oldOwner=mutation.payload.idOwner;
        this.esecutori=[...mutation.payload.esecutori];
        this.initialValues.status=mutation.payload.status
        this.initialValues.descrizione=mutation.payload.dodAttuale
        this.oldDescrizione=mutation.payload.dodAttuale;
        this.idTicket=mutation.payload.idTicket
        this.orePreviste=mutation.payload.orePreviste
        this.forcePM=mutation.payload.forcePM;
        this.idPmForzato=mutation.payload.idPmForzato;
      }

      if (mutation.type === 'ownerUpdated') {
        this.annulla();
      }
    });
  },
  methods: {
    resolver: ({ values }) => {
      const errors = {};
      if (!values.esecutore) {
        errors.esecutore = [{ message: 'Selezionare un esecutore.' }];
      }
      return {
        errors
      };
    },
    onFormSubmit({values, states, valid, errors}) {
      if(valid){

        let nuovoTaskSprint={
          taskId:this.idTask,
          status:states.status.value,
          idOwner:states.esecutore.value,
          oldOwner:this.oldOwner,
          descrizione:states.descrizione.value,
          oldDescrizione:this.oldDescrizione,
          idTicket:this.idTicket,
          orePreviste:this.orePreviste,
          forcePM:this.forcePM,
          idPmForzato:this.idPmForzato
        }
        this.$store.dispatch('updateOwner',{...nuovoTaskSprint});
      }
    },
    annulla(){
      this.show=false;
      this.status="";
      this.idTask=-1
    },
  }
}
</script>